Highcharts.light =
  colors: ["#5f90a0", "#e89645", "#86a644", "#e77660", "#e0cc0e", "#996798", "#55aaa0",
  "#66513a", "#fbc5ff", "#6d3333", "#4572A7", "#DF5353", "#3E4D2B", "#F1C900", "#ff0066",
  "#266B15", "#55BF3B", "#5F0CDB", "#7798BF", "#aaeeee"]
  chart:
    backgroundColor: "transparent"
    borderWidth: 0
    borderRadius: 0
    plotBackgroundColor: null
    plotShadow: false
    plotBorderWidth: 0

  title:
    text: ''
    align: 'left'
    style:
      color: "#222"
      font: "16px proxima-nova, ProximaNova, Helvetica Neue, Helvetica, Arial, sans-serif"

  credits:
    enabled: false

  subtitle:
    style:
      color: "#444"
      font: "12px proxima-nova, ProximaNova, Helvetica Neue, Helvetica, Arial, sans-serif"

  xAxis:
    gridLineWidth: .5
    gridLineColor: "#eee"
    lineColor: "#aaa"
    tickColor: "#aaa"
    labels:
      style:
        color: "#777"
        fontWeight: "normal"
        fontSize: "11px"

      step: 10

    title:
      style:
        color: "#888"
        font: "bold 12px proxima-nova, ProximaNova, Helvetica Neue, Helvetica, Arial, sans-serif"

  yAxis:
    alternateGridColor: null
    minorTickInterval: null
    gridLineWidth: .5
    gridLineColor: "#eee"
    lineWidth: 1
    tickWidth: 1
    lineColor: "#aaa"
    tickColor: "#aaa"
    labels:
      style:
        color: "#777"
        fontWeight: "bold"

    title:
      text: ''
      style:
        color: "#666"
        font: "bold 12px proxima-nova, ProximaNova, Helvetica Neue, Helvetica, Arial, sans-serif"

  legend:
    borderWidth: 0
    itemStyle:
      color: "#333"
      fontSize: "11px"
      fontWeight: "normal"

    symbolRadius: 2
    squareSymbol: false
    symbolHeight: 12
    symbolWidth: 16

    itemHoverStyle:
      color: "#111"

    itemHiddenStyle:
      color: "#aaa"

  labels:
    style:
      color: "#aaa"

  tooltip:
    shared: true
    useHTML: true
    backgroundColor: "rgba(255, 255, 255, .90)"
    borderWidth: 1
    borderRadius: 4
    borderColor: "#eee"
    shadow: false
    style:
      color: "#222"

  plotOptions:
    area:
      stacking: 'normal'
      marker:
        enabled: true
        radius: 2
        symbol: "circle"

    line:
      dataLabels:
        color: "#888"

      lineWidth: 2
      marker:
        enabled: true
        lineColor: null
        lineWidth: 0
        radius: 2
        states:
          hover:
            enabled: true

        symbol: "circle"

    pie:
      size: "80%"
      innerSize: "35%"
      dataLabels:
        distance: 15

    series:
      dataLabels:
        color: "#888"
      animation: false

      lineWidth: 2
      shadow: false
      marker:
        lineColor: null
        lineWidth: 0
        states:
          hover:
            enabled: true

    column:
      borderWidth: 0

    spline:
      marker:
        lineColor: "#333"

    scatter:
      marker:
        lineColor: "#333"

    candlestick:
      lineColor: "white"

    bar:
      borderWidth: 0

    funnel:
      center: ["40%", "50%"]
      neckHeight: "25%"
      neckWidth: "25%"
      width: "70%"

  toolbar:
    itemStyle:
      color: "#CCC"

  navigation:
    buttonOptions:
      backgroundColor:
        linearGradient: [0, 0, 0, 20]
        stops: [[0.4, "#f7f7f7"], [0.6, "#fefefe"]]

      borderRadius: 2
      borderColor: "#aaaaaa"
      hoverBorderColor: "#999999"
      y: 5

  exporting:
    enabled: false

  
  # scroll charts
  rangeSelector:
    buttonTheme:
      fill:
        linearGradient: [0, 0, 0, 20]
        stops: [[0.4, "#888"], [0.6, "#555"]]

      stroke: "#000000"
      style:
        color: "#CCC"
        fontWeight: "bold"

      states:
        hover:
          fill:
            linearGradient: [0, 0, 0, 20]
            stops: [[0.4, "#BBB"], [0.6, "#888"]]

          stroke: "#000000"
          style:
            color: "white"

        select:
          fill:
            linearGradient: [0, 0, 0, 20]
            stops: [[0.1, "#000"], [0.3, "#333"]]

          stroke: "#000000"
          style:
            color: "yellow"

    inputStyle:
      backgroundColor: "#333"
      color: "silver"

    labelStyle:
      color: "silver"

  navigator:
    handles:
      backgroundColor: "#666"
      borderColor: "#AAA"

    outlineColor: "#CCC"
    maskFill: "rgba(16, 16, 16, 0.5)"
    series:
      color: "#7798BF"
      lineColor: "#ffffff"

  scrollbar:
    barBackgroundColor:
      linearGradient: [0, 0, 0, 20]
      stops: [[0.4, "#888"], [0.6, "#555"]]

    barBorderColor: "#CCC"
    buttonArrowColor: "#CCC"
    buttonBackgroundColor:
      linearGradient: [0, 0, 0, 20]
      stops: [[0.4, "#888"], [0.6, "#555"]]

    buttonBorderColor: "#CCC"
    rifleColor: "#FFF"
    trackBackgroundColor:
      linearGradient: [0, 0, 0, 10]
      stops: [[0, "#000"], [1, "#333"]]

    trackBorderColor: "#666"

  
  # special colors for some of the demo examples
  legendBackgroundColor: "rgba(48, 48, 48, 0.8)"
  legendBackgroundColorSolid: "rgb(70, 70, 70)"
  dataLabelsColor: "#444"
  textColor: "#E0E0E0"
  maskColor: "rgba(255,255,255,0.3)"
